'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ACTION_CONTEXTS } from '../constants/actionContexts.constants';
import ActionContextPropType from '../propTypes/ActionContextPropType';
import makeMessageKeyUtil from '../utils/makeMessageKeyUtil.util';
import { OUTAGE_REASONS } from '../constants/outageReasons.constants';
import ServiceAvailabilityStatusPropType from '../propTypes/ServiceAvailabilityStatusPropType';
const messageKeyUtil = makeMessageKeyUtil('fintech-outage-banner.title');

const FintechOutageBannerTitle = ({
  serviceAvailabilityStatus,
  actionContext = ACTION_CONTEXTS.ANY
}) => {
  const actionKey = actionContext === ACTION_CONTEXTS.PURCHASE ? 'purchase' : 'any';
  const reason = (serviceAvailabilityStatus || {}).outageReason;
  const reasonKey = reason === OUTAGE_REASONS.PLANNED_OUTAGE ? 'planned' : 'unplanned';
  const messageKey = `${reasonKey}-${actionKey}`;
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: messageKeyUtil(messageKey)
  });
};

FintechOutageBannerTitle.propTypes = {
  serviceAvailabilityStatus: ServiceAvailabilityStatusPropType,
  actionContext: ActionContextPropType
};
export default FintechOutageBannerTitle;